$(() => {
  // Auto-submit the admin Users filter form whenever a filter changes. Previously each
  // control carried an inline onchange="this.form.submit();" attribute; moved here so it
  // satisfies the script-src-attr 'self' CSP directive instead of tripping a violation.
  $('#admin-users-filters').on('change', 'input, select', function() {
    this.form.submit();
  });
});
